import { actionTypes } from "./constants";
const initialState = {
  faqList: {
    list: [],
    total: 0,
  },
  faqAllList: {
    list: [],
    total: 0,
  },
  faqTree: {},
  faqTreeFormat: [],
  faqAllDetail: {},
  faqDetail: {},
};

const treePrefix = {
  PRODUCT: "PRODUCT",
  CATEGORY: "CATEGORY",
  SOLUTION: "SOLUTION",
};

const treeType = {
  按产品: "PRODUCT",
};

const productFormat = (productList, type) => {
  const format = (productList, pid) => {
    const formatList = [];
    productList.forEach(_p => {
      if (!_p.hasOwnProperty('model')) {
        const obj = {
          key: `${treePrefix[type]}-${_p.id}`,
          id: _p.id,
          title: _p.title,
          type: treePrefix.CATEGORY,
          children: format(_p.products, _p.id)
        };
        formatList.push(obj);
        return ;
      }
      formatList.push({
        key: `${treePrefix[type]}-${pid}-${treePrefix.PRODUCT}-${_p.id}`,
        id: _p.id,
        title: _p.model,
        productTitle: _p.title,
        type: treePrefix.PRODUCT,
      });
    });
    return formatList;
  };
  return format(productList, 0);
};

const formatFaqCenterTree = (data) => {
  const formatTree = [];
  Object.keys(data).forEach(key => {
    formatTree.push({
      key: key,
      title: key,
      children: productFormat(data[key], treeType[key]),
    });
  });

  return formatTree;
};

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_FAQ_LIST:
      return {
        ...state, faqList: action.data, 
      };
    case actionTypes.SET_FAQ_ALL_LIST:
      return {
        ...state, faqAllList: action.data,
      };
    case actionTypes.SET_FAQ_TREE:
      return {
        ...state, faqTree: action.data,faqTreeFormat: formatFaqCenterTree(action.data),
      };
    case actionTypes.SET_FAQ_DETAIL:
      return {
        ...state, faqDetail: action.data
      };
    case actionTypes.SET_FAQ_ALL_DETAIL:
      return {
        ...state, faqAllDetail: action.data
      };
    default:
      return state;
  }
};